module.exports = function() {
  return new Worker(__webpack_public_path__ + "fb7e62fe24f703a52045.worker.js");
};